import { render, staticRenderFns } from "./TabbedContentTab.vue?vue&type=template&id=a98b6e20&"
import script from "./TabbedContentTab.vue?vue&type=script&lang=js&"
export * from "./TabbedContentTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports